import ExpanderBoxViewModelT from '@/ViewModels/Controls/ExpanderBoxViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ControlViewModelBuilder from '@/Builder/ControlViewModelBuilder';
import LinkViewModelBuilder from '@/Builder/LinkViewModelBuilder';
import { IExpanderBoxViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';
import StorageHelper from '@/Utility/StorageHelper';

export default class ExpanderBoxViewModelBuilder<T = null> extends ControlViewModelBuilder<ExpanderBoxViewModelT, T> {

    protected properties: IExpanderBoxViewModelConstructorParameter;
    private linkBuilder: LinkViewModelBuilder<this>;

    public constructor(parent?: T) {
        super(parent);
    }

    public withLabelErgName(ergName: string): this {
        this.properties.labelErgName = ergName;
        return this;
    }

    public withLink(): LinkViewModelBuilder<this> {
        if (this.linkBuilder == null)
            this.linkBuilder = new LinkViewModelBuilder<this>(this);

        return this.linkBuilder;
    }

    public withIsCollapsed(isCollapsed: ObservableOrDefault<boolean>): this {
        this.properties.isCollapsed = isCollapsed;

        return this;
    }

    public withIsCollapsedFromStorage(key: string, defaultValue: boolean): this {
        this.properties.isCollapsed = StorageHelper.bind(key + '_Collapsed', defaultValue);

        return this;
    }

    /**
     * @override
     * @inheritdoc 
     */
    protected buildInternal(): ExpanderBoxViewModelT {
        const ExpanderBoxViewModel = ComponentManager.getViewModel<typeof ExpanderBoxViewModelT>('ExpanderBoxViewModel');

        this.properties.link = this.linkBuilder ? this.linkBuilder.build() : null;

        return new ExpanderBoxViewModel(this.properties);
    }
}